<template>
  <div class="community-comment" :class="{ child }">
    <div class="d-flex">
      <div class="comment-picture mr-4">
        <span v-if="!comment.avatar">{{ comment.name[0] }}</span>
        <img v-else class="comment-avatar" :src="comment.avatar" alt="" />
      </div>

      <div class="comment-body">
        <span class="d-flex align-items-center comment-owner">
          {{ comment.name }}
          <span class="comment-time"> há 2 dias</span>
        </span>
        <b-dropdown
          v-if="$user.user && comment.user_id === $user.user.id"
          variant="link"
          toggle-class="text-decoration-none"
          right
        >
          <template #button-content>
            <i class="icon-menu"></i>
          </template>
          <b-dropdown-item @click="editing = true">Editar</b-dropdown-item>
          <b-dropdown-item @click="removing = true">Excluir</b-dropdown-item>
        </b-dropdown>

        <p class="my-2">{{ comment.text }}</p>

        <div class="row pt-3" v-if="!child">
          <div class="buttons">
            <button
              class="btn-interaction mr-4"
              :class="{ 'text-primary': comment.liked }"
              @click="like"
            >
              <img
                v-if="!comment.liked"
                src="@/assets/svg/like.svg"
                key="liked"
              />
              <img v-else src="@/assets/svg/liked.svg" />
              <span class="count">{{ comment.like }}</span>
            </button>

            <button class="btn-interaction mr-4">
              <img src="@/assets/svg/comment.svg" key="liked" />
              <span v-if="comment.childers" class="count">
                {{ comment.childers.length }}
              </span>
            </button>

            <button class="btn-interaction" @click="answering = true">
              Responder
            </button>
          </div>
        </div>

        <div v-for="child in comment.childers" :key="child.id" class="mt-3">
          <community-comment :comment="child" child />
        </div>

        <send-comment
          class="mt-3"
          v-if="answering"
          :lesson="comment.lesson"
          :parent="comment.id"
          @cancel="answering = false"
          @success="$emit('success')"
        />

        <b-modal v-model="editing" hide-header hide-footer centered>
          <form @submit.prevent="edit">
            <h5 class="text-center text-light mb-4">Editar comentário</h5>
            <form-group
              placeholder="Comentar..."
              id="text"
              v-model="form.text"
              :errors="errors.text"
              textarea
            />
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-block btn-secondary"
                  @click="editing = false"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button type="submit" class="btn btn-block btn-primary">
                  <loading :show="loading">Salvar</loading>
                </button>
              </div>
            </div>
          </form>
        </b-modal>

        <b-modal v-model="removing" hide-header hide-footer centered>
          <h5 class="text-center text-light mb-4">
            Tem certeza que deseja excluir?
          </h5>
          <div class="row">
            <div class="col-6">
              <button
                class="btn btn-block btn-secondary"
                @click="removing = false"
              >
                Cancelar
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-block btn-primary" @click="remove">
                <loading :show="loading">Sim, excluir</loading>
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import SendComment from "./SendComment";
import { formFields } from "@/functions/helpers";

export default {
  name: "community-comment",
  components: { SendComment },
  props: {
    comment: {
      type: Object,
      default: () => ({})
    },
    child: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      answering: false,
      editing: false,
      removing: false,
      loading: false,
      ...formFields(["text"], { ...this.comment })
    };
  },
  methods: {
    like() {
      this.comment.liked = !this.comment.liked;
      this.comment.like = this.comment.liked
        ? this.comment.like + 1
        : this.comment.like - 1;
      this.$store
        .dispatch("forum/interact", {
          comment_id: this.comment.id,
          like: this.comment.liked
        })
        .catch(() => {
          this.comment.liked = !this.comment.liked;
        });
    },
    remove() {
      this.loading = true;
      this.$store
        .dispatch("forum/remove", this.comment.id)
        .then(() => {
          this.$message.success("Comentário excluído com sucesso");
          this.removing = false;
          this.$emit("success");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit() {
      this.loading = true;
      this.$store
        .dispatch("forum/edit", {
          ...this.comment,
          ...this.form
        })
        .then(() => {
          this.$message.success("Comentário editado com sucesso");
          this.editing = false;
          this.$emit("success");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.community-comment {
  padding: 16px 0px;
  position: relative;
  border-radius: 2px;

  &.child {
    padding: 16px;
    .comment-picture {
      min-width: 32px;
      max-width: 32px;
      height: 32px;
      font-size: 20px;
    }
  }

  .buttons {
    display: flex;
    margin-left: 15px;
  }

  .btn-interaction {
    border: none;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    color: white;
    font-size: 14px;
    font-weight: 600;

    i {
      font-size: 16px;
      margin-right: 6px;
    }

    img {
      max-height: 20px;
      margin-right: 4px;
    }
  }

  ::v-deep .dropdown {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  ::v-deep .dropdown-toggle {
    font-size: 24px;

    &::after {
      display: none;
    }
  }

  .comment-picture {
    border-radius: 50%;
    background-color: #919191;
    min-width: 48px;
    max-width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
  .comment-avatar {
    height: 48px;
    width: 48px;
    object-fit: cover;
    border-radius: 48px;
  }

  .comment-owner {
    font-size: 14px;
    font-weight: 700;
  }
  .comment-time {
    margin-left: 16px;
    font-size: 12px;
  }

  .count {
    color: #d7d7d7;
    display: inline-flex;
    align-items: center;
  }

  .icon-menu {
    color: rgba(255, 255, 255, 0.7);
  }

  .avatar {
    margin-right: 8px;
    padding: 1px;
    border: 1px solid $primary;
    border-radius: 100%;

    img {
      max-width: 32px;
      max-height: 32px;
      min-width: 32px;
      min-height: 32px;
      border-radius: 100%;
      object-fit: cover;
    }
  }
}
</style>
